import { useState, useEffect } from 'react';
import { Link, NavLink, useLocation, useNavigate } from 'react-router-dom';
import logo from '../assets/images/logo.svg';

const Navigation = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [activeSection, setActiveSection] = useState('');
  const location = useLocation();
  const navigate = useNavigate();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  // Detectar se é mobile
  const isMobile = window.innerWidth < 992;

  // Função para navegação com scroll suave
  const handleNavigation = (path, sectionId = null) => {
    closeMenu();
    
    if (sectionId) {
      setActiveSection(sectionId);
      
      if (location.pathname === '/') {
        // Se já está na home, faz scroll suave
        setTimeout(() => {
          const element = document.getElementById(sectionId);
          if (element) {
            const offset = 80; // Ajuste para o header fixo
            const elementPosition = element.getBoundingClientRect().top;
            const offsetPosition = elementPosition + window.pageYOffset - offset;
            
            window.scrollTo({
              top: offsetPosition,
              behavior: 'smooth'
            });
          }
        }, 100);
      } else {
        // Se não está na home, navega para home e depois scroll
        navigate('/');
        setTimeout(() => {
          const element = document.getElementById(sectionId);
          if (element) {
            const offset = 80;
            const elementPosition = element.getBoundingClientRect().top;
            const offsetPosition = elementPosition + window.pageYOffset - offset;
            
            window.scrollTo({
              top: offsetPosition,
              behavior: 'smooth'
            });
          }
        }, 500);
      }
    } else {
      setActiveSection('');
      navigate(path);
    }
  };

  // Fechar menu ao redimensionar para desktop
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 992) {
        closeMenu();
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Fechar menu ao clicar fora (para mobile)
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (isMenuOpen && isMobile) {
        const navbar = document.querySelector('.navbar-collapse');
        const toggler = document.querySelector('.navbar-toggler');
        
        if (navbar && !navbar.contains(event.target) && !toggler.contains(event.target)) {
          closeMenu();
        }
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isMenuOpen, isMobile]);

  return (
    <nav className="navbar navbar-expand-lg navbar-light bg-white shadow-sm p-3 custom-navbar fixed-top">
      <div className="container container-top">
        <Link 
          className="navbar-brand d-flex align-items-center text_logo" 
          to="/"
          onClick={() => setActiveSection('')}
        >
          <img 
            src={logo} 
            alt="Logo do site" 
            width="40" 
            height="35" 
            className="me-2"
          />
          Yasserv
        </Link>

        <button
          className="navbar-toggler"
          type="button"
          aria-label="Toggle navigation"
          aria-expanded={isMenuOpen}
          aria-controls="navbarNav"
          onClick={toggleMenu}
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div 
          className={`collapse navbar-collapse ${isMenuOpen ? 'show' : ''}`}
          id="navbarNav"
        >
          <ul className="navbar-nav ms-auto align-items-center text_menu">
            <li className="nav-item space_margin">
              <button
                onClick={() => handleNavigation('/', 'home')}
                className={`text_menu border-0 bg-transparent ${
                  activeSection === 'home' ? 'active fw-bold' : ''
                }`}
              >
                Home
              </button>
            </li>
           
            <li className="nav-item space_margin">
              <button
                onClick={() => handleNavigation('/', 'beneficios')}
                className={`text_menu border-0 bg-transparent ${
                  activeSection === 'beneficios' ? 'active fw-bold' : ''
                }`}
              >
                Benefícios
              </button>
            </li>

            <li className="nav-item space_margin">
              <button
                onClick={() => handleNavigation('/', 'sobre')}
                className={`text_menu border-0 bg-transparent ${
                  activeSection === 'sobre' ? 'active fw-bold' : ''
                }`}
              >
                Soluções
              </button>
            </li>
            
            <li className="nav-item space_margin">
              <button
                onClick={() => handleNavigation('/', 'contato')}
                className={`text_menu border-0 bg-transparent ${
                  activeSection === 'contato' ? 'active fw-bold' : ''
                }`}
              >
                
                Entrar em Contato
              </button>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;